import React from "react";
import { Tooltip, Button, Progress } from "antd";

const getResourceType = (resourceLink) => {
  if (!resourceLink) return "unknown";
  const lowerLink = resourceLink.toLowerCase();
  if (lowerLink.includes("youtube.com") || lowerLink.includes("youtu.be")) return "youtube";
  if (lowerLink.endsWith(".mp4") || lowerLink.endsWith(".mov")) return "video";
  if (lowerLink.endsWith(".pdf") || lowerLink.includes(".pdf")) return "stored-file";
  if (lowerLink.startsWith("http://") || lowerLink.startsWith("https://")) return "website";
  return "stored-file";
};

const getProgressColor = (record) => {
  const { completionPercentage, minCompletionPercentage, acknowledged } = record;
  if (acknowledged) return "#088A15";
  if (completionPercentage >= minCompletionPercentage) return "#1777FF";
  return "#FFB200";
};

const buttonStyle = {
  borderColor: "#910E11",
  color: "#910E11",
  borderRadius: "6px",
  fontWeight: 500,
  width: "120px",
};

export const getMarkDoneButtonStyle = (record) => {
  const canMarkComplete = record.completionPercentage >= record.minCompletionPercentage;
  if (record.acknowledged) return {
    width: "123px", height: "36px",
    backgroundColor: "#088A15", borderColor: "#088A15",
    color: "#ffffff", fontWeight: 500, cursor: "default",
  };
  if (canMarkComplete) return {
    width: "123px", height: "36px",
    borderColor: "#066710", color: "#066710",
    fontWeight: 500, backgroundColor: "transparent",
  };
  return {
    width: "123px", height: "36px",
    borderColor: "#d9d9d9", color: "#00000040",
    backgroundColor: "transparent",
  };
};

export const getCourseContentColumns = ({
  setSelectedRecord,
  setShowContent,
  onMarkDone,
}) => [
  {
    title: "Content Title",
    dataIndex: "title",
    key: "title",
    width: "30%",
    ellipsis: true,
    render: (text) => (
      <Tooltip title={text} placement="topLeft" mouseEnterDelay={0.3}>
        <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", cursor: "pointer" }}>
          {text || "N/A"}
        </div>
      </Tooltip>
    ),
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    width: "25%",
    ellipsis: true,
    render: (text) => (
      <Tooltip title={text} placement="topLeft" mouseEnterDelay={0.3}>
        <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", cursor: "pointer" }}>
          {text || "N/A"}
        </div>
      </Tooltip>
    ),
  },
  {
    title: "Status",
    dataIndex: "completionPercentage",
    key: "completionPercentage",
    width: "20%",
    render: (progress, record) => {
      const strokeColor = getProgressColor(record);
      return (
        <Progress
          percent={progress}
          size="small"
          strokeColor={strokeColor}
          showInfo={true}
          format={(percent) => (
            <span style={{ fontFamily: "Inter", fontWeight: 500, fontSize: "12px", color: strokeColor }}>
              {percent}%
            </span>
          )}
        />
      );
    },
  },
  {
    title: "Action",
    key: "action",
    width: "15%",
    render: (_, record) => {
      if (!record.resourceLink) return "N/A";
      const resourceType = getResourceType(record.resourceLink);
      const label = {
        youtube: "YouTube Link",
        video: "Video",
        pdf: "PDF",
        "stored-file": "PDF",
        website: "Website",
      }[resourceType] || "View";

      return (
        <Button
          style={buttonStyle}
          onClick={() => {
            if (resourceType === "website") {
              window.open(record.resourceLink, "_blank");
            } else {
              setSelectedRecord(record);
              setShowContent(true);
            }
          }}
        >
          {label}
        </Button>
      );
    },
  },
  {
    title: "Acknowledgement",
    key: "acknowledgement",
    width: "15%",
    render: (_, record) => {
      const canMarkComplete = record.completionPercentage >= record.minCompletionPercentage;
      return (
        <Tooltip
          title={
            !canMarkComplete
              ? `Minimum completion required: ${record.minCompletionPercentage}%. Current: ${record.completionPercentage}%`
              : record.acknowledged
              ? "Already marked as completed"
              : "Acknowledge Content"
          }
        >
          <Button
            style={getMarkDoneButtonStyle(record)}
            disabled={!record.acknowledged && !canMarkComplete}
            onClick={() => !record.acknowledged && onMarkDone(record)}
          >
            {record.acknowledged ? "Completed" : "Mark as done"}
          </Button>
        </Tooltip>
      );
    },
  },
];